import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function () {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/Pricing";

        GET(url)
            .then((response) => {
                dispatch({
                    type: "APPLICATION_PRICING_RETRIEVED",
                    pricings: response.data
                });

                dispatch(CreateDataRetrievalEndedAction());
            })
            .catch((error) => {
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}
